import { num } from './format'
import { NAME_W, ROLE_W, META_W, CELL_W } from './layout'

export function TotalsRow({ label, values, months, monthValues, total, bold, muted,
                           digits = 0, canEdit, fixed }) {
  const tone = bold ? 'font-semibold text-gray-900'
    : muted ? 'text-gray-400' : 'text-gray-600'
  return (
    <tr className={`bg-white border-t border-gray-200 ${tone}`}>
      <td {...fixed(0, NAME_W, 'bg-white px-3 py-1.5 border-r border-gray-100')} colSpan={1}>
        {label}
      </td>
      <td {...fixed(NAME_W, ROLE_W, 'bg-white border-r border-gray-100')} />
      <td {...fixed(NAME_W + ROLE_W, META_W, 'bg-white border-r border-gray-100')} />
      {values.map((v, i) => (
        <td key={i} className="px-1 py-1.5 text-center tabular-nums"
            style={{ width: CELL_W, minWidth: CELL_W }}>
          {v ? num(v, digits) : ''}
        </td>
      ))}
      {months.map((m, i) => (
        <td key={`${m.year}-${m.month}`}
            className="px-2 py-1.5 text-right tabular-nums bg-gray-50">
          {monthValues ? num(monthValues[i]) : ''}
        </td>
      ))}
      <td className="px-3 py-1.5 text-right tabular-nums">
        {total != null ? num(total) : ''}
      </td>
      {canEdit && <td />}
    </tr>
  )
}
